const ABViewWidgetCore = require("../../core/views/ABViewWidgetCore");
module.exports = class ABViewWidget extends ABViewWidgetCore {};
